module.exports = __webpack_public_path__ + "@/assets/img/chart-line2.8e2af6e4.svg";